await import(/* webpackChunkName: "formValidation" */ 'Feature/Forms/code/Scripts/formValidation');

await import(/* webpackChunkName: "form" */ 'Feature/Forms/code/Scripts/form.validate');
await import(/* webpackChunkName: "form" */ 'Feature/Forms/code/Scripts/form.tracking');
await import(/* webpackChunkName: "form" */ 'Feature/Forms/code/Scripts/form.conditions');

await import(/* webpackChunkName: "messages_de" */ 'Feature/Forms/code/Scripts/localization/messages_de.js');

await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

await import(/* webpackChunkName: "regularExpressionCustomValidator" */ 'Feature/Forms/code/Scripts/regularExpressionCustomValidator');
await import(/* webpackChunkName: "blockHtmlValidator" */ 'Feature/Forms/code/Scripts/blockHtmlValidator');
await import(/* webpackChunkName: "blockSqlValidator" */ 'Feature/Forms/code/Scripts/blockSqlValidator');
await import(/* webpackChunkName: "blockUrlValidator" */ 'Feature/Forms/code/Scripts/blockUrlValidator');
await import(/* webpackChunkName: "nameValidator" */ 'Feature/Forms/code/Scripts/nameValidator');

await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');